import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SimpleAction } from '../../../contextual-actions/contextual-actions.component';
import { Terminal } from '../../../../../../@core/domain/interfaces/terminal.interface';
import { NbIconConfig, NbLayoutRulerService, NbToastrService } from '@nebular/theme';
import { TrackingService } from '../../../../../../@shared/services/tracking.service';
import { IdentificationSearchService } from '../../../../../../@shared/services/identifications-search.service';
import { TerminalsApiService } from '../../../../../../@core/api/terminals-api.service';
import { StatusPageService } from '../../../../services/status-page.service';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../../../../../../@core';
import { AnonymousGrantPassageWithReasonTerminalAction } from '../../../../../../@core/domain/interfaces/terminal-action.interface';

type Nullable<T> = T | null;

@Component({
  selector: 'app-anonymous-passage',
  templateUrl: './anonymous-passage.component.html',
  styleUrls: ['./anonymous-passage.component.scss'],
})
export class AnonymousPassageComponent implements OnInit {
  @Input()
  terminal!: Terminal;

  @Input()
  action!: SimpleAction;

  @Output()
  changeComponent = new EventEmitter<string>();

  selectedItem: any;
  grantPassageForm!: UntypedFormGroup;
  index!: number;
  awaitTerminalActionComplete = false;
  toastrMessage = '';
  passageResponseMessage!: string;
  passageResponseStatus = 'success';
  showTerminalTitle = true;
  hideElement = false;
  errorMessage!: Nullable<string>;

  constructor(
    private terminalsApiService: TerminalsApiService,
    private formBuilder: UntypedFormBuilder,
    private statusPageService: StatusPageService,
    private toastrService: NbToastrService,
    private translate: TranslateService,
    private logger: LogService,
    private layoutRuleService: NbLayoutRulerService,
    private identificationsSearchService: IdentificationSearchService,
    private trackingService: TrackingService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.selectedItem = '';

    this.getWindowSize();
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this.getWindowSize();
  }

  getWindowSize() {
    this.layoutRuleService.getDimensions().subscribe((data) => {
      this.showTerminalTitle = data.clientWidth >= 1024;
      this.hideElement = data.clientWidth <= 425;
    });

    // do not show terminal title on small screen here
    // make sure scroll works correct
  }

  buildForm() {
    if (this.action && this.action.type === 28) {
      this.grantPassageForm = this.formBuilder.group({
        reason: ['', [Validators.required]],
        remarks: ['', []],
      });
    } else {
      this.grantPassageForm = this.formBuilder.group({
        reason: [''],
        remarks: [''],
      });
    }
  }

  submitAnonymousGrantPassage(): void {
    if (+this.grantPassageForm.value.reason === 0 && !this.grantPassageForm.value.remarks) {
      this.translate.get('GRANT_PASSAGE.REMARK_REQUIRED').subscribe((t) => {
        this.errorMessage = t;
        return;
      });
    } else {
      this.errorMessage = null;
      this.trackingService.eventEmitter(
        'passageComponent',
        'action',
        '',
        'anonymousGrantPassage',
        0
      );
      if (this.grantPassageForm.valid) {
        const terminalAction: AnonymousGrantPassageWithReasonTerminalAction = {
          reason: +this.grantPassageForm.value.reason,
          remarks: this.grantPassageForm.value.remarks,
          type: this.action.type,
        };
        this.awaitTerminalActionComplete = true;
        this.terminalsApiService
          .sendTerminalAction(this.terminal.id, terminalAction)
          .subscribe((result) => {
            if (result.success) {
              this.passageResponseStatus = 'success';
              this.awaitTerminalActionComplete = false;
              this.grantPassageForm.reset();
              this.logger.info(
                'Terminal action ' + terminalAction + ' performed on terminal' + this.terminal.id
              );
              this.passageResponseMessage = result.message;
              this.handleTerminalActionResponse(terminalAction, result, 'success');
            } else {
              this.logger.info(
                'Terminal action ' + terminalAction + ' failed on terminal' + this.terminal.id
              );
              this.passageResponseStatus = 'danger';
              this.passageResponseMessage = result.message;
              this.handleTerminalActionResponse(terminalAction, result, 'danger');
            }
          });
      }
    }
  }

  switchControlledGrantPassage() {
    this.changeComponent.emit('grantControlledPassage');
  }

  private handleTerminalActionResponse(terminalAction: any, result: any, displayType: string) {
    this.awaitTerminalActionComplete = false;
    const iconConfig: NbIconConfig = { icon: 'alert-triangle-outline', pack: 'eva' };
    this.showToast(result.message, this.toastrMessage, {
      status: displayType,
      hasIcon: true,
      icon: iconConfig,
      duration: 5000,
    });
  }

  private showToast(message: string, title: string, config: any): void {
    this.index += 1;
    this.toastrService.show(message, title, config);
  }
}
